import Button, { ButtonProps } from '@mui/material/Button';
import { ReactNode, MouseEvent } from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { green } from '@mui/material/colors';
import useApplication from '../../hooks/useApplication.hooks';
interface StandardButtonProps extends ButtonProps {
    showLoading?: boolean;
    children?: ReactNode;
    icon: ReactNode;
}

const StandardButton = (props: StandardButtonProps) => {
    const { showLoading = false, children, icon, onClick, disabled, variant, ...restProps } = props;
    const { isLoading, setIsLoading } = useApplication();

    const handleClick = async (e: MouseEvent<HTMLButtonElement>) => {
        if (showLoading) {
            setIsLoading(true);
        }

        try {
            if (onClick) {
                await onClick(e);
            }
        } catch (err) {
            throw err;
        } finally {
            if (showLoading) {
                setIsLoading(false);
            }
        }
    };

    const color = isLoading ? 'grey' : 'white';

    return (
        <Button
            {...restProps}
            endIcon={icon}
            disabled={isLoading || disabled}
            onClick={handleClick}
            variant={variant ? variant : 'outlined'}
            style={{ color: color }}
        >
            {isLoading && showLoading && (
                <CircularProgress
                    size={24}
                    sx={{
                        color: green[500],
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-12px',
                        marginLeft: '-12px',
                    }}
                />
            )}

            {children}
        </Button>
    );
};

export default StandardButton;
